<template>
  <div class="fullscreen-overlay">
    <div
      style="
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 600px;
      ">
      <img
        style="
          margin-bottom: 50px;
          margin-left: 50px;
          margin-right: 50px;
          width: 120px;
          height: 120px;
        "
        v-if="deluge.canvaspro_core_info?.product_name.toUpperCase() === 'OMNI'"
        :src="omniSvg" />
      <img
        style="
          margin-bottom: 50px;
          margin-left: 50px;
          margin-right: 50px;
          width: 120px;
          height: 120px;
        "
        v-if="deluge.canvaspro_core_info?.product_name.toUpperCase() === 'ONE'"
        :src="oneSvg" />
      <img
        style="
          margin-bottom: 50px;
          margin-left: 50px;
          margin-right: 50px;
          width: 120px;
          height: 120px;
        "
        v-if="deluge.canvaspro_core_info?.product_name.toUpperCase() === 'ORB'"
        :src="orbSvg" />
      <div
        style="
          color: white;
          font-size: 24px;
          font-weight: bolder;
          margin-bottom: 40px;
        "
        class="CanvasProFont">
        End User License Agreement
      </div>
      <div
        style="
          color: white;
          height: 500px;
          width: 600px;
          overflow: auto;
          white-space: pre-wrap;
        ">
        {{ eula }}
      </div>

      <div
        style="display: flex; justify-content: space-between; width: 600px"
        class="mt-4">
        <v-spacer />
        <v-btn
          color="primary"
          style="width: 200px"
          @click="
            accepteula();
            emit('close');
          "
          :loading="loading"
          prepend-icon="mdi-check-circle">
          Accept
        </v-btn>
      </div>
    </div>
  </div>
</template>
<script setup>
import omniSvg from '../../assets/OmniLight.svg';
import oneSvg from '../../assets/OneLight.svg';
import orbSvg from '../../assets/CanvasPro_Orb_Anagram_White_7680px.svg';
import { deluge, state } from '@/stores/deluge.js';
import { $http } from '../../stores/http.js';
import { ref } from 'vue';
import eula from '../../../license.txt?raw';

const emit = defineEmits(['close']);

const cpro_name = ref(deluge.canvaspro_core_info?.domain);
const cpro_admin_pass = ref(undefined);
const cpro_admin_email = ref(undefined);
const loading = ref(false);
const window = ref(false);

async function quick_start() {
  loading.value = true;
  if (cpro_name.value || cpro_admin_pass.value || cpro_admin_email.value) {
    await save();
    login();
    loading.value = false;
  }
}
async function accepteula() {
  try {
    await $http('PUT', '/accept_eula');
  } catch (error) {
    console.log(error);
  }
}
function login() {
  const FD = new FormData();
  var request = new XMLHttpRequest();
  FD.append('username', 'admin');
  FD.append('password', cpro_admin_pass.value);
  request.open('POST', state.devRedirect + '/api/token', FD);
  request.onload = () => {
    if (request.status !== 200) {
      alert('Username or password denied');
    }
    var respObj = JSON.parse(request.responseText);
    if ('access_token' in respObj) {
      localStorage.setItem('username', 'admin');
      localStorage.setItem('authentication_token', respObj.access_token);

      emit('complete', respObj);
    }
  };
  request.onerror = () => {
    alert('Username or password denied');
  };
  request.send(FD);
}
async function save() {
  try {
    await $http(
      'POST',
      '/initial_register',
      JSON.stringify({
        admin_pass: cpro_admin_pass.value,
        admin_email: cpro_admin_email.value,
        name: cpro_name.value,
        eula_accepted: true,
      })
    );
  } catch (error) {
    console.log(error);
  }
}
</script>
<style scoped>
.fullscreen-overlay {
  height: 100vh;
  height: 100dvh;
  height: -webkit-fill-available;
  height: calc(var(--vh, 1vh) * 100);
  width: 100vw;
  background: #1a1a1f;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 99999999;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  opacity: 1;
}
</style>
